/* src/app/components/filters-modal/filters-modal.component.scss */
.wrapper {
  width: 100%;
  background: #f2f2f2;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
  height: 100%;
  overflow: auto;
  padding: 45px 15px 25px;
}
ion-img {
  width: 50px;
}
.title {
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
  margin-bottom: 25px;
}
.cross {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 25px;
  width: 25px;
  padding: 3px;
}
.options {
  background: white;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 4.5rem;
}
.option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  background: #fff;
  margin-bottom: 5px;
  width: 100%;
  border-bottom: 1px solid #e8e8df;
  border-radius: 9px;
  cursor: pointer;
}
.option:last-child {
  border-bottom: none;
}
.option span {
  font-size: 1rem;
}
.option .switch {
  width: 63px;
  height: 23px;
  background: rgba(255, 255, 255, 0.3019607843);
  border: 1px solid #000000;
  border-radius: 999px;
  display: flex;
  align-items: center;
  transition: background 0.3s;
  margin-right: 15px;
}
.option .switch.active {
  background: rgba(198, 164, 117, 0.3019607843);
}
.option .switch .knob {
  width: 42px;
  height: 23px;
  background: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transform: translateX(-1px);
  transition: transform 0.3s;
}
.option .switch.active .knob {
  background: #9f7b52;
  transform: translateX(20px);
}
.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
}
/*# sourceMappingURL=filters-modal.component.css.map */
